"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileAppenderLoadError = exports.LazyComponentLoadingError = exports.ListenerCallbackError = exports.UnregisteredComponentUsedError = exports.UnregisteredMethodInvokedError = exports.ReactModuleContainerError = void 0;
class ReactModuleContainerError extends Error {
    constructor(message) {
        super(message);
        this.name = this.constructor.name;
        if (typeof Error.captureStackTrace === 'function') {
            Error.captureStackTrace(this, this.constructor);
        }
        else {
            this.stack = new Error(message).stack;
        }
    }
}
exports.ReactModuleContainerError = ReactModuleContainerError;
class UnregisteredMethodInvokedError extends ReactModuleContainerError {
    constructor(methodName) {
        super(`ModuleRegistry.invoke ${methodName} used but not yet registered`);
        this.name = 'UnregisteredMethodInvokedError';
    }
}
exports.UnregisteredMethodInvokedError = UnregisteredMethodInvokedError;
class UnregisteredComponentUsedError extends ReactModuleContainerError {
    constructor(componentId) {
        super(`ModuleRegistry.component ${componentId} used but not yet registered`);
        this.name = 'UnregisteredComponentUsedError';
    }
}
exports.UnregisteredComponentUsedError = UnregisteredComponentUsedError;
class ListenerCallbackError extends ReactModuleContainerError {
    constructor(methodName, error) {
        super(`Error in listener callback of module registry method: ${methodName}`);
        this.name = 'ListenerCallbackError';
        this.stack += error.stack;
        this.originalError = error;
    }
}
exports.ListenerCallbackError = ListenerCallbackError;
class LazyComponentLoadingError extends ReactModuleContainerError {
    constructor(component, error) {
        super(`Error loading moduleRegistry lazy component ${component}`);
        this.name = 'LazyComponentLoadingError';
        this.stack += error.stack;
        this.originalError = error;
    }
}
exports.LazyComponentLoadingError = LazyComponentLoadingError;
class FileAppenderLoadError extends ReactModuleContainerError {
    constructor(fileUrl) {
        super(`FilesAppender failed to load file ${fileUrl}`);
        this.name = 'FileAppenderLoadError';
    }
}
exports.FileAppenderLoadError = FileAppenderLoadError;
//# sourceMappingURL=ReactModuleContainerErrors.js.map